<div class="row p-4">
    <h1 class="text-center font-style">
        Explore more below
    </h1>
</div>